import { DRAWER_WIDTH } from 'Util/constants'
import { Box, Button, Paper, Typography } from '@mui/material'
import { t } from 'ttag'

interface BulkTicketSaleBottomBarProps {
  ticketAmount?: number | string
  zoneFromName?: string
  zoneToName?: string
  onCancel?: () => void
  isLoading: boolean
  actionButtonLabel: string
  onActionButtonClick: () => void
  startIcon?: React.ReactNode
}

export default function BulkTicketSaleBottomBar({
  ticketAmount,
  zoneFromName,
  zoneToName,
  onCancel,
  isLoading,
  actionButtonLabel,
  onActionButtonClick,
  startIcon
}: Readonly<BulkTicketSaleBottomBarProps>) {
  return (
    <Paper
      elevation={1}
      square
      sx={{
        position: 'fixed',
        bottom: 0,
        left: `${DRAWER_WIDTH}px`,
        right: 0,
        px: 4,
        py: 2,
        borderTop: 1,
        borderBottom: 1,
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: theme => theme.zIndex.appBar
      }}
    >
      <Box
        sx={{
          flex: '1 1 0',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}
      >
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: 12,
            fontWeight: 400,
            textTransform: 'uppercase',
            lineHeight: '19.92px',
            letterSpacing: '1px'
          }}
        >
          {t`Summary`}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap' }}>
          <Typography variant="body2">{t`You are creating`}</Typography>
          <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 700 }}>
            {ticketAmount && !Number.isNaN(Number(ticketAmount)) ? ticketAmount : '-'}
          </Typography>
          <Typography variant="body2">{t`tickets for zone range`}</Typography>
          <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 700 }}>
            {zoneFromName && zoneToName ? `${zoneFromName} - ${zoneToName}` : '-'}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          flex: '1 1 0',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 2
        }}
      >
        {onCancel && (
          <Button variant="outlined" size="large" onClick={onCancel}>
            {t`Cancel`}
          </Button>
        )}
        <Button
          variant="contained"
          size="large"
          onClick={onActionButtonClick}
          loading={isLoading}
          loadingPosition="start"
          disableElevation
          startIcon={startIcon}
        >
          {actionButtonLabel}
        </Button>
      </Box>
    </Paper>
  )
}
